import Vue from "vue";

/**
 * 2022 Acceptance Testing Forms
 *
 * Version 1.0
 */

 // NRCA-LTO-02-A
Vue.component('photo-control-2022', require('./NRCA-LTO-02-A/PhotoControl'));
Vue.component('automatic-scheduling-control-2022', require('./NRCA-LTO-02-A/AutomaticSchedulingControl'));
Vue.component('motion-sensing-control-2022', require('./NRCA-LTO-02-A/MotionSensingControl'));

// NRCA-LTI-05-A
Vue.component('observation-institutional-tuning-2022', require('./NRCA-LTI-05-A/InstitutionalTuningObservation'));
Vue.component('verification-institutional-tuning-2022', require('./NRCA-LTI-05-A/InstitutionalTuningVerification'));

// NRCA-LTI-04-A
Vue.component('demand-response-illuminance-measurement-2022', require('./NRCA-LTI-04-A/DrIlluminanceMeasurement'));
Vue.component('demand-response-current-measurement-2022', require('./NRCA-LTI-04-A/DrCurrentMeasurement'));
Vue.component('demand-response-full-facility-current-measurement-2022', require('./NRCA-LTI-04-A/FullFacilityCurrentMeasurement'));
Vue.component('demand-response-controlled-receptacle-2022', require('./NRCA-LTI-04-A/DRControlledReceptacle'));

// NRCA-LTI-03-A
Vue.component('continuous-dimming-2022', require('./NRCA-LTI-03-A/ContinuousDimmingControlSystem'));
Vue.component('stepped-dimming-2022', require('./NRCA-LTI-03-A/SteppedDimmingControlSystem'));


// NRCA-LTI-02
Vue.component('automatic-time-switch-2022', require('./NRCA-LTI-02-A/AutomaticTimeSwitch.js'));
Vue.component('occupant-sensing-2022', require('./NRCA-LTI-02-A/OccupancySensor.js'));
Vue.component('multi-zone-occupant-sensing-2022', require('./NRCA-LTI-02-A/MultiZoneOccupancySensor.js'));
